// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AdobePhotoshopIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      fill="#001E36"
      d="M5.54 2h12.92A3.6 3.6 0 0 1 22 5.63v12.74c0 2-1.58 3.63-3.54 3.63H5.54A3.6 3.6 0 0 1 2 18.37V5.63C2 3.63 3.58 2 5.54 2"
    />
    <path
      fill="#31A8FF"
      d="M6.5 16.03v-8.8q0-.1.08-.1h.47l.63-.02q.34 0 .73-.02h.76q1.02 0 1.71.26.63.23 1.12.7.4.4.6.98.2.53.2 1.1 0 1.11-.5 1.83-.51.72-1.34 1.04-.86.3-1.88.3-.3 0-.41-.02H8.3v2.74a.1.1 0 0 1-.1.12H6.6q-.1 0-.1-.11m1.82-7.24v2.87l.32.02h.44q.5 0 .96-.16.4-.13.69-.45.25-.32.25-.88.02-.41-.19-.76-.21-.34-.58-.49-.47-.19-.99-.17h-.56q-.26 0-.34.02M18 11.14a4.3 4.3 0 0 0-1.73-.4q-.27-.01-.5.05-.17.04-.26.18a1 1 0 0 0-.07.23q0 .11.08.22.12.14.29.23.29.15.59.28.68.24 1.28.63.42.26.66.7.2.42.2.89 0 .62-.33 1.13-.36.52-.94.76-.6.28-1.5.28a6 6 0 0 1-1.14-.11 3 3 0 0 1-.85-.28q-.1-.06-.09-.16v-1.49q0-.04.03-.07.04-.02.08 0 .49.3 1.03.42.48.13.99.13.47 0 .69-.12a.4.4 0 0 0 .22-.36q0-.18-.2-.34a4 4 0 0 0-.81-.4 5 5 0 0 1-1.19-.62 2 2 0 0 1-.63-.72q-.2-.43-.2-.88 0-.54.3-1.03.3-.51.87-.79.59-.3 1.47-.3a7 7 0 0 1 1.03.08q.38.05.72.2.06.01.08.08l.02.1v1.4a.1.1 0 0 1-.04.08z"
    />
  </svg>,
  "AdobePhotoshop",
);
export default AdobePhotoshopIcon;
